import { Observable } from 'rxjs';
import { ExistingProvider, InjectionToken } from '@angular/core';
import { Constructable } from 'morphism/dist/types/types';

export const LISTENERS = new InjectionToken<Listener>('');

export interface Listener {
  init(): Promise<void>;

  close(): Promise<void>;

  readonly name: string;
  readonly isAvailable$: Observable<boolean>;
  readonly isAvailable: boolean;
}

export class MultiListenerProvider implements ExistingProvider {
  constructor(public readonly useExisting: Constructable<Listener> | InjectionToken<Listener>) {}

  public readonly provide = LISTENERS;
  public readonly multi = true;
}
